import React, { Component } from "react";
import StackedOrderedBox from "./components/StackedOrderedBox";
import { graphql, compose } from "react-apollo";
import { queryGetTotalCaseCount, queryGetTotalCustomerCount } from "Apollo";
import { GetAnalyticFilter } from "Store";
import { observer } from "mobx-react";

const gqlOptions = {
  options: {
    fetchPolicy: "network-only"
  }
};

const Box = compose(
  graphql(queryGetTotalCaseCount, { ...gqlOptions, name: "case" }),
  graphql(queryGetTotalCustomerCount, { ...gqlOptions, name: "customer" })
)(
  class CaseAndCustomer extends Component {
    render() {
      const {
        case: { getTotalCaseCount, caseLoading },
        customer: { getTotalCustomerCount, customerLoading }
      } = this.props;
      let caseCount = 0;
      let customerCount = 0;
      if (!caseLoading && getTotalCaseCount) {
        caseCount = getTotalCaseCount.data[0]
          ? getTotalCaseCount.data[0].value
          : 0;
      }
      if (!customerLoading && getTotalCustomerCount) {
        customerCount = getTotalCustomerCount.data[0]
          ? getTotalCustomerCount.data[0].value
          : 0;
      }
      const opt = {
        contentList: [
          {
            title: "Case",
            content: caseCount
          },
          {
            title: "Customer",
            content: customerCount
          }
        ]
      };
      return <StackedOrderedBox {...opt} />;
    }
  }
);

export default observer(
  class BoxWithQuery extends Component {
    render() {
      return <Box {...GetAnalyticFilter()} />;
    }
  }
);



// WEBPACK FOOTER //
// ./src/module-analytics/CaseAndCustomer.js